import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "./../../Constant";
import Swal from "sweetalert2";

export default class AdminLogin extends Component {
  state = {
    email: "",
    password: "",
    userName: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    institute: "",
  };
  componentDidMount() { }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSiteAdd = () => { };
  onLogin = (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/admin/login", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          localStorage.setItem("livelms_auth", result.auth);
          localStorage.setItem("livelms_login", true);
          localStorage.setItem("livelms_role", "superadmin");
          localStorage.setItem("livelms_firstName", result.userName);
          localStorage.setItem("lms_uid", result.id);
          window.location.href = "#/admin/dashboard";
          window.location.reload();
        } else {
          Swal.fire("Error", "Incorrect email and password!", "error");
        }

      })
      .catch((error) => console.log("error", error));
  };

  render() {
    return (
      <div className="py-3 row m-0">
        <div className="col-md-6 mx-auto bg-white shadow-sm p-5 rounded">
          <h3 className="m-0 text-center text-primary mb-5">Admin Login</h3>

          <form onSubmit={this.onLogin}>
            {/* <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                Domain Name
              </label>
              <div class="input-group col-6 p-0">
                <div class=" d-flex">
                  <input
                    type="text"
                    class="form-control p-1 px-2 h-100"
                    placeholder="Enter Domain Name"
                    name="institute"
                    value={this.state.institute}
                    onChange={this.onInputChange}
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">.livelms.in</span>
                  </div>
                </div>
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div> */}
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                Email
              </label>
              <div className="col-6 p-0">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Enter Email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>

            {/* <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                First Name
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter First Name"
                  name="firstName"
                  value={this.state.firstName}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                Last Name
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Last Name"
                  name="lastName"
                  value={this.state.lastName}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                Username
              </label>
              <div className="col-6 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Username"
                  name="userName"
                  value={this.state.userName}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div> */}
            <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right"
                for="inputDefault"
              >
                Password
              </label>
              <div className="col-6 p-0">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Enter Password"
                  name="password"
                  value={this.state.password}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div>
            {/* <div class="form-group row">
              <label
                class="col-form-label text-uppercase col-5 text-right pl-0"
                for="inputDefault"
              >
                Confirm Password
              </label>
              <div className="col-6 p-0">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Enter Confirm Password"
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.onInputChange}
                />
                <div class="invalid-feedback">
                  Sorry, that username's taken. Try another?
                </div>
              </div>
            </div> */}

            <div className="row pt-3">
              <div className="col-5"></div>
              <div className="col-6 p-0">
                <input
                  type="submit"
                  className="btn btn-bg text-uppercase font-weight-bold rounded shadow-sm btn-primary"
                  value="LOGIN"
                  onClick={this.onLogin}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
